(function () {
  'use strict';

  /* @ngdoc object
   * @name manageRoles
   * @description
   *
   */
  angular
    .module('manageRoles', [
      'ui.router'
    ]);
}());
